
import React from "react";
import { Link } from "react-router-dom";
import { formatDate } from "@/lib/format";
import { BlogPost } from "@/types/blogTypes";

interface BlogPostCardProps {
  post: BlogPost;
}

const BlogPostCard: React.FC<BlogPostCardProps> = ({ post }) => {
  return (
    <Link 
      to={`/blog/${post.slug}`} 
      className="group block overflow-hidden rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
    >
      {post.featuredImage && (
        <div className="relative h-48 overflow-hidden">
          <img
            src={post.featuredImage}
            alt={post.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          {post.category && (
            <span className="absolute top-3 right-3 bg-[#FA8C00] text-white px-2 py-1 rounded text-xs font-medium shadow-sm">
              {post.category}
            </span>
          )}
        </div>
      )}
      
      <div className="p-5">
        <h3 className="text-xl font-semibold mb-2 text-secondary group-hover:text-[#FA8C00] transition-colors">
          {post.title}
        </h3>
        
        <div className="text-sm text-secondary/60 mb-3 flex items-center">
          <time dateTime={post.publishedAt}>{formatDate(post.publishedAt)}</time>
          {post.readTime && (
            <>
              <span className="mx-2">•</span>
              <span>{post.readTime} min read</span>
            </>
          )}
        </div>
        
        <p className="text-secondary/80 line-clamp-3 mb-4">
          {post.excerpt}
        </p>
        
        <div className="flex justify-between items-center">
          <span className="text-[#4ba3c7] font-medium group-hover:underline">
            Read more
          </span>
          
          {post.author && (
            <div className="flex items-center">
              {post.author.avatarUrl ? (
                <img 
                  src={post.author.avatarUrl} 
                  alt={post.author.name}
                  className="w-6 h-6 rounded-full mr-2"
                />
              ) : (
                <div className="w-6 h-6 rounded-full bg-[#FA8C00] text-white flex items-center justify-center text-xs mr-2">
                  {post.author.name.substring(0, 1)}
                </div>
              )}
              <span className="text-sm text-secondary/80">{post.author.name}</span>
            </div>
          )}
        </div>
      </div>
    </Link>
  );
};

export default BlogPostCard;
